<template>
    <div class="eml-user-labels-ctn">
        <template>
            <li v-if="show_search_box">
                <o-input class="search-box" placeholder="Search..."
                    icon="magnify"
                    size="is-small"
                    type="search"
                    v-model="searchTerm"
                />
            </li>
            <div :class="['eml-user-labels-wrapper', { 'active': show_search_box }]">
                <div class="eml-user-labels">
                    <div class="eml-menu-item" v-for="(item, key) in filtered_labels" :key="key">
                        <o-tooltip :label="item.name" position="is-top">
                            <router-link :class="{'is-active': isActive(item), 'eml-item-ctn': true}" @click.native="handleEmailLabelMenu(item, $event)" :to="{ name: 'emails', params: { label: item.id } }" active-class="activated">
                                <div class="eml-menu-icon" :style="`--bg-image: url('${item.iconUrl}');`"></div>
                                <div class="eml-menu-item-txt-ctn"><span class="eml-menu-item-text">{{ item.name }}</span>
                                <span class="badge is-pulled-right">
                                    {{getBadge(item)}}
                                </span>
                                </div>
                            </router-link>
                        </o-tooltip>
                    </div>
                </div>
            </div>
            <div class="eml-user-labels" v-if="show_all">
                <div class="eml-menu-item eml-expand">
                    <o-tooltip :label="expanded_text">
                        <a class="eml-item-ctn" @click.prevent="expanded = !expanded">
                            <o-icon :icon="!expanded && 'chevron-down' || 'chevron-up'" size="is-small"></o-icon>
                            <div class="eml-menu-item-txt-ctn"><span class="eml-menu-item-text">{{ expanded_text }}</span>
                            </div>
                        </a>
                    </o-tooltip>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    const labels_filter = (l, ctx) => {
                    // const r = new RegExp(`^.*${l}.*$`, envigado)
                    return (!ctx.searchTerm || ctx.searchTerm.length < 2) || new RegExp(`^.*${ctx.searchTerm}.*$`, 'gi').test(l.name)
                }

    export default {
        components: {
        },
        computed: {
            ...mapGetters([
                'emails_is_signed_in',
                'emails_label',
                'emails_labels',
            ]),
            expanded_text() {
                return this.expanded && 'Less' || 'More'
            },
            filtered_labels() {
                return this.expanded && this.labels.filter(this.labels_filter) || (this.show_all && this.firsts_labels) || this.labels
            },
            firsts_labels() {
                return this.labels.slice(0,2)
            },
            show_all() {
                return this.labels.length > 2
            },
            show_search_box() {
                return this.show_all && this.expanded
            },
        },
        data () {
            return {
                expanded: false,
                searchTerm: '',
            }
        },
        methods: {
            ...mapActions(['closeSidebar', ]),
            ...mapActions({
                labels_filter(x,label_item) {
                    return labels_filter(label_item, this)
                },
            }),
            getBadge(item) {
                return (item.id === 'UNREAD' && this.emails_labels.INBOX.threadsUnread) || (item.id === 'DRAFT' && item.threadsTotal) || item.threadsUnread || '0'
            },
            handleEmailLabelMenu(item, e) {
                this.closeSidebar(e)
            },
            isActive(item) {
                return this.emails_label.split(',')[0] === item.id
            },
        },
        mounted() {
        },
        props: {
            labels: {
                default () {
                    return []
                },
                required: false,
                type: Array,
            },
        },
    }
</script>
<style lang="sass">
.eml-user-labels-ctn
  max-width: 175px
  padding: 8px 0
  li
    .search-box
      padding: 0 16px 0 22px
  .eml-user-labels-wrapper
    position: relative
    &.active
      margin-top: 6px
  .eml-user-labels
    max-height: 340px
    overflow-x: hidden
    overflow-y: auto
    .eml-menu-item
      margin-top: 2px
      &:first-child > .b-tooltip
        position: static
      &>.b-tooltip
        display: flex
        flex: 1
        flex-direction: column
      &.eml-expand
        .eml-menu-item-txt-ctn
          margin-top: 3px
          margin-left: 9px
      .eml-item-ctn
        color: rgba(255, 255, 255, 0.5)
        align-items: center
        border-radius: 0 16px 16px 0
        display: flex
        height: 32px
        padding: 0 12px 0 21px
        transition: margin .15s cubic-bezier(0.4,0.0,0.2,1),padding .15s cubic-bezier(0.4,0.0,0.2,1)
        &.is-active
          background-color: #019ae0
          color: white
          .eml-menu-icon
            opacity: 1
          .eml-menu-item-text, .badge
            padding-top: 2px
        .eml-menu-icon
          align-items: center
          display: flex
          flex-shrink: 0
          height: 20px
          justify-content: flex-start
          margin-right: 6px
          opacity: 0.54
          width: 20px
          &:before
            content: ''
            background-image: var(--bg-image)
            background-position: center
            background-repeat: no-repeat
            background-size: 20px
            display: block
            height: 20px
            width: 20px
        .eml-menu-item-txt-ctn
          line-height: 20px
          overflow: hidden
          padding-right: 5px
          text-overflow: ellipsis
          white-space: nowrap
          width: 100%
          .eml-menu-item-text
            display: inline-block
            max-width: 75%
            overflow: hidden
            padding-left: 6px
            text-overflow: ellipsis
          .badge
            display: block
            font-size: .75rem
            font-weight: 700
            letter-spacing: .3px
            line-height: 21px
            text-shadow: none
</style>